import { Routes } from '@angular/router';
import { RedirectComponent } from './Pages/redirect/redirect.component';
import { PaymentThankYouComponent } from './Pages/redirect/payment-thank-you.component';

export const routes: Routes = [
    { path: 'redirect', component: RedirectComponent },
    { path: 'thank-you', component: PaymentThankYouComponent },
    { path: '', data: { title: 'iN2Padel' }, loadChildren: () => import('./Pages/landing-page/landing-page.module').then((m) => m.LandingPageModule) }
];
